import { useEffect } from 'react';
import { useGetActiveCurrencyQuery } from '@/store/api/currencyApi';
import { setCurrencySymbol } from '@/utils/currencySymbol';

// Platform's actual configured currency symbol (backend CURRENCY_SYMBOL),
// replacing the old hardcoded '৳' left over from the original
// Bangladesh-market build. Mounted once for the app's lifetime in
// AppLayout, so it's already cached by the time any page needs it.
export const useCurrencySymbol = (): string => {
  const { data } = useGetActiveCurrencyQuery();
  const symbol = data?.data?.symbol ?? '';

  useEffect(() => {
    setCurrencySymbol(symbol);
  }, [symbol]);

  return symbol;
};
